import React from "react";
import HeaderUnauthenticated from "../Headers/HeaderUnauthenticated";

function LoadingScreen() {
  return (
    <>
      <HeaderUnauthenticated title=""/>
    </>
  );
}

export default LoadingScreen;
